"use client";

import dynamic from "next/dynamic";

export const AgentsWrapper = dynamic(() => import("./Agents").then(mod => mod.Agents));
